Alpine.store('customModal', {
    openedModals: {},
    timeouts: {},

    init () {
        window.addEventListener('customer-information-modal::open', () => {
            this.openedModals = {};
        });
    },

    addItem(eventName) {
        this.openedModals[eventName] = true;
    },

    removeItem(eventName) {
        delete this.openedModals[eventName];
    },

    isCurrent(eventName) {
        return Object.keys(this.openedModals).pop() === eventName;
    },

    open(eventName) {
        this.addItem(eventName);

        clearTimeout(this.timeouts[eventName]);

        return true;
    },

    close(eventName, ignoreEvent = false) {
        if (this.isCurrent(eventName)) {
            if (!ignoreEvent) {
                dispatchEvent(new CustomEvent('close-'+eventName));
            }

            clearTimeout(this.timeouts[eventName]);

            this.timeouts[eventName] = setTimeout(() => {
                dispatchEvent(new CustomEvent('reset-'+eventName));
            }, 5000);

            this.removeItem(eventName);
        }
    }
});
